import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { FilterAlt } from "@mui/icons-material";
import { CustomIconButton } from "../../shared/CustomIconButton";
import axios from "axios";
import {Switch} from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";


import { toast } from "react-toastify";


const Subscription = () => {
  const [data, setData] = useState([]);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const StoreID = localStorage.getItem("store_id");
  // const mainCategoryList=()=>{
  //   axios
  //     .post(
  //       `https://app1.crazzyhub.com/api/admin/multivendor-show-main-category-list/`,
  //       {
  //         store_id: StoreID,
  //       },
  //       {
  //         headers: {
  //           Token: localStorage.getItem("Token"),
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setMainCAtegoryData(response?.data?.main_category_data);
  //     })
  //     .catch((error) => {
  //       console.log("", error);
  //     });
  // }
  // useEffect(()=>{
  //   mainCategoryList()
  // },[])

  
  // const subCategoryList=()=>{
  //   axios
  //     .post(
  //       `https://app1.crazzyhub.com/api/admin/multivendor-show-sub-category-list-by-id/`,
  //       { main_category_id: mainCategoryId },
  //       {
  //         headers: {
  //           Token: localStorage.getItem("Token")
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setSubCategoryData(response?.data?.sub_cat_list);
  //     })
  //     .catch((error) => {
  //       console.log("error page", error.response);
  //       console.log(error);
  //     });
  // }

  // useEffect(() => {
  //   subCategoryList()
  // }, [mainCategoryId]);


  // const brandList=()=>{
  //   axios
  //     .post(
  //       `https://app1.crazzyhub.com/api/admin/multivendor-show-brand-list/`,
  //       { store_id: StoreID },
  //       {
  //         headers: {
  //           Token: localStorage.getItem("Token"),
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       setBrandData(response?.data?.brand);
  //     })
  //     .catch((error) => {
  //       console.log("", error);
  //     });
  // }
  // useEffect(()=>{
  //   brandList()
  // },[])



  const inventoryData = () => {
    axios
      .post(
        `https://app1.crazzyhub.com/api/admin/product-list-admin/`,
        {
          store_id: StoreID,
        },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setData(response?.data?.data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    inventoryData();
  }, []);



 

  const Enable = (id) => {
    axios
      .post(
        `https://app1.crazzyhub.com/api/admin/activate-store-product-for-subscription/`,
        { product_id:id.toString()},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.message);
        inventoryData()

      })
      .catch((error) => {
        console.log("", error.response);
        console.log(error);
      });
  };
 
  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Subscription Product Anable/Disable List
          </p>
          <p className="!text-black">View/Search Enventry Management List</p>
        </div>
      
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            <CustomIconButton>
              <FilterAlt onClick={handleOpen} className="!text-black" />
            </CustomIconButton>
            <input
              type="text" 
              className="!border-3 !border-black !w-72 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }} />
          </span>        
        </div>
        <TableContainer
          component={Paper}
          // sx={{  }}
          sx={{ width: "100%", maxHeight: 440 }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {/* <TableCell className="!text-left !p-2">
                  <Checkbox className="!m-0 !text-black" />
                </TableCell> */}
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  PRODUCT NAME
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  IMAGE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  PRICE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  MRP
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  SGST
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  CGST
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  IGST
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  QUANTITY
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ACTION
                </TableCell>
               
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.id ? row.id : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.title ? row.title : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.image ? (
                        <img src={row.image} alt="No" className="h-8 w-8" />
                      ) : (
                        "--"
                      )}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                     ₹ {row?.price ? row?.price : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                     ₹ {row?.mrp ? row?.mrp : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                    {row?.sgst ? row?.sgst +" %" : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                    {row?.cgst ? row?.cgst +" %" : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                    {row?.igst ? row?.igst +" %" : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.quantity ? row?.quantity : "--"}
                    </TableCell>

                   
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                 <Switch defaultChecked={row?.is_active_return}
                  onChange={(event) =>Enable(row?.id)}
                 />
                    </TableCell>
                   
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <div
          className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
          style={{ marginRight: "0px" }}
        >
          <button className="!float-right">
            <ArrowForwardIosIcon />
          </button>
          <button className="float-right">
            <ArrowBackIosIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
